import LABEL from '../../business-const/Label/Label'



const tipoCalculoAcumuladoList = [
    {
        id: 'AA',
        descricao: 'Até a ' + LABEL.aposentadoria,
        ordem: 10,
    },
    {
        id: 'VT',
        descricao: 'Vitalício',
        ordem: 20,
    },
    {
        id: 'II',
        descricao: 'A Partir do Início do INSS',
        ordem: 30,
    },
    {
        id: 'PA',
        descricao: 'Após a ' + LABEL.aposentadoria,
        ordem: 30,
    },
]

export default tipoCalculoAcumuladoList